import NavigationManager from '@v2/domains/routing/components/NavigationManager'
import { Outlet } from 'react-router-dom'

import styles from './auth-template.module.scss'

const AuthLayout = () => {
  return (
    <>
      <NavigationManager />

      <div className={styles.wrapper}>
        <div className={styles.sidebarWrapper}>
          <div className={styles.sidebarInner}>
            <Outlet />
          </div>
        </div>

        <div className={styles.image} />
      </div>
    </>
  )
}

export default AuthLayout
